import {BASE_API_URL} from '../constants'
import Token from "./Token";


export const SearchPropertiesApi = {
    byZip: (zipcode) => {
        return fetch(
            BASE_API_URL + '/api/properties?zipcode=' + zipcode,
            {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + Token.getToken()
                }
            },
        ).then(r => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    },
    byId: (propertyUuid) => {
        return fetch(
            BASE_API_URL + '/api/properties/' + propertyUuid,
            {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + Token.getToken()
                }
            },
        ).then(r => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    }
}